import React, {Component} from 'react';
import Api from "../../utils/Api";
import PropTypes from "prop-types";
import Timeformat from "../../utils/Timeformat";
import Job from "../../utils/Job";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";

class MachineDesignHistory extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
        page: PropTypes.number,
        maxRows: PropTypes.number,
    };

    static defaultProps = {
        page: 0,
        maxRows: 50
    };

    constructor(props) {

        super(props);

        this.state = {
            history: null,
        };

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.page = props.page;

        this.getHistory = this.getHistory.bind(this);
        this.getHistory();

        this.updateHistoryJob = new Job(this.getHistory, 30000);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.page !== this.page) {
            this.page = nextProps.page;
            this.getHistory();
        }

    }

    componentWillUnmount() {

        this.updateHistoryJob.stop();

    }

    getHistory() {

        if (this.state.history !== null) {
            this.setState({
                history: null
            });
        }

        const companyId = (this.props.baseData) ? this.props.baseData.companies.currentCompany.id : null;
        const machineId = (this.props.machine) ? this.props.machine.machine_id : null;

        if (companyId === null || machineId === null) return null;

        const params = {
            companyId: companyId,
            machineId: machineId,
            rows: this.props.maxRows,
            offset: this.props.maxRows * this.page
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    history: res
                });
            }
        }.bind(this);

        this.api.request('GetMachineDesignHistory', params, callback, null);

    }

    getRows() {

        if (!this.state.history) return null;

        const timezone = this.props.baseData.companies.currentCompany.timezone;

        return <tbody>{
            this.state.history.map(
                (x, i) => {
                    let dateCreated = (x.dateInserted) ? Timeformat.fromUnix(x.dateInserted).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

                    return <tr key={'trx' + i}>
                        <td className="text-left">
                            <DesignPreviewContainer
                                baseData={this.props.baseData}
                                designId={x.designId}
								designStitches={x.stitches}
                            />
                        </td>
                        <td className="text-left">{x.designId}</td>
                        <td className="text-left">{x.name}</td>
                        <td className="text-right">{x.stitches}</td>
                        <td className="text-right">{x.passings}</td>
                        <td className="text-right">{dateCreated}</td>
                    </tr>
                }
            )
        }</tbody>

    }

    render() {

        if (!this.state.history) {
            return (
                <div style={{paddingTop: 50}}>
                    <LoadingSplash color={'#0e3043'}/>
                </div>
            );
        }

        const rows = this.getRows();

        return (
            <div className="bottomcontainer tablecontainer">
                {/*<!-- modified Bootstrap tables  -->*/}
                <table className="table">
                    <thead>
                        <tr>
                            <th className="text-left">{this.translate('design')}</th>
                            <th className="text-left">{this.translate('designId')}</th>
                            <th className="text-left">{this.translate('designName')}</th>
                            <th className="text-right">{this.translate('stitches')}</th>
                            <th className="text-right">{this.translate('passings')}</th>
                            <th className="text-right">{this.translate('date')}</th>
                        </tr>
                    </thead>

                    {rows}
                </table>
                {/*<!-- / modified Bootstrap tables  -->*/}
            </div>
        );

    }

}

export default MachineDesignHistory;
